import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

import { UntypedFormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  static oneOfValidator(rules: Array<ValidatorFn>, commonError: any): ValidatorFn {
    return (control: UntypedFormControl) => {
        if(rules.find(r=>!r(control))){
            return null;
        }
        return commonError;
    };

}
}
